// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1160":"130f63ea","1844":"5717ba56","5288":"b6affa77","8976":"17b1496f"}[chunkId] + ".chunk.css";
};